import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronDownOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6 8.625 3.75-3.75-.742-.742L6 7.14 2.992 4.132l-.742.743z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronDownOutlinedSize12Glyph.displayName = 'ChevronDownOutlinedSize12Glyph';
